export default function InitGallerySliders() {
	const galleries = document.querySelectorAll('.wp-block-gallery.slider');

	galleries.forEach((gallery) => {
		const items = Array.from(gallery.querySelectorAll('.wp-block-image'));
		if (items.length < 2) return;

		let currentIndex = 0;

		// Wrap gallery content
		gallery.style.position = 'relative';
		gallery.style.overflow = 'hidden';

		// Create track
		const track = document.createElement('div');
		track.className = 'gallery-slider__track';
		items.forEach((item) => {
			item.classList.add('gallery-slider__slide');
			track.appendChild(item);
		});
		gallery.innerHTML = '';
		gallery.appendChild(track);

		// Create nav
		const nav = document.createElement('div');
		nav.className = 'gallery-slider__nav';

		const prevBtn = document.createElement('button');
		prevBtn.className = 'gallery-slider__btn gallery-slider__btn--prev';
		prevBtn.setAttribute('aria-label', 'Previous slide');
		prevBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7L9 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		const nextBtn = document.createElement('button');
		nextBtn.className = 'gallery-slider__btn gallery-slider__btn--next';
		nextBtn.setAttribute('aria-label', 'Next slide');
		nextBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 2L10 7L5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

		nav.appendChild(prevBtn);
		nav.appendChild(nextBtn);
		gallery.appendChild(nav);

		function goTo(index) {
			currentIndex = index;
			track.style.transform = `translateX(-${currentIndex * 100}%)`;
		}

		prevBtn.addEventListener('click', () => {
			goTo(currentIndex <= 0 ? items.length - 1 : currentIndex - 1);
		});

		nextBtn.addEventListener('click', () => {
			goTo(currentIndex >= items.length - 1 ? 0 : currentIndex + 1);
		});
	});
}
